require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[1],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(134);


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Accordion = _interopRequireDefault(__webpack_require__(135));

exports["default"] = _Accordion["default"];
exports.Accordion = _Accordion["default"];

var _AccordionItem = _interopRequireDefault(__webpack_require__(136));

exports.AccordionItem = _AccordionItem["default"];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _baUiCarbon = __webpack_require__(12);

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Accordion = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Accordion, _Component);

  function Accordion() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        icon = _this$props.icon,
        otherCarbonAccordionProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["align", "icon"]);
    var mappedAlign = (align != null ? align : icon === 'right') ? undefined : 'start';
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Accordion, (0, _extends2["default"])({}, otherCarbonAccordionProps, {
      align: mappedAlign
    }));
  };

  return Accordion;
}(_react.Component);

exports["default"] = Accordion;
(0, _defineProperty2["default"])(Accordion, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Accordion.propTypes, {
  /** deprecated - Use Carbon align prop */
  icon: BaPropTypes.deprecated(' deprecated - Use Carbon align prop')
}));

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

__webpack_require__(137);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

var AccordionItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(AccordionItem, _Component);

  function AccordionItem() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AccordionItem.prototype;

  _proto.focus = function focus() {
    this._node && this._node.focus();
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        parentDisabled = _this$props.parentDisabled,
        icon = _this$props.icon,
        itemName = _this$props.itemName,
        children = _this$props.children,
        parentIcon = _this$props.parentIcon,
        style = _this$props.style,
        triggerButtonExtraOptions = _this$props.triggerButtonExtraOptions,
        collapseExtraOptions = _this$props.collapseExtraOptions,
        childRef = _this$props.childRef,
        index = _this$props.index,
        open = _this$props.open,
        onChange = _this$props.onChange,
        fullWidth = _this$props.fullWidth,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "disabled", "parentDisabled", "icon", "itemName", "children", "parentIcon", "style", "triggerButtonExtraOptions", "collapseExtraOptions", "childRef", "index", "open", "onChange", "fullWidth"]);
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.AccordionItem, (0, _extends2["default"])({}, sanitize(others, AccordionItem), {
      "data-index": index,
      "aria-label": itemName,
      title: itemName,
      className: (fullWidth ? 'is-fullWidth' : '') + " " + (className != null ? className : ''),
      style: style,
      open: open,
      onHeadingClick: function onHeadingClick(data) {
        return onChange && onChange(data.isOpen);
      },
      ref: function ref(r) {
        return _this._node = r;
      }
    }), children);
  };

  return AccordionItem;
}(_react.Component);

exports["default"] = AccordionItem;
(0, _defineProperty2["default"])(AccordionItem, "propTypes", {
  /** Ref for each item header(button) */
  childRef: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Child element(s) inside the item */
  children: _propTypes["default"].node,

  /** extra options for collapse component */
  collapseExtraOptions: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Disables accordion item */
  disabled: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Where to place icon for the item */
  icon: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Index of each item */
  index: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** item label */
  itemName: _propTypes["default"].string,

  /** Callback function when the item is toggled */
  onChange: _propTypes["default"].func,

  /** opens the item */
  open: _propTypes["default"].bool,

  /** Disables parrent element */
  parentDisabled: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Where to place the parrent element icon */
  parentIcon: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** extra options for the item trigger button */
  triggerButtonExtraOptions: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),

  /** Allows content of the accordionItem to span the entire width.  Enhancement request https://github.com/carbon-design-system/carbon/issues/7174 */
  fullWidth: _propTypes["default"].bool
});

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(138);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".bx--accordion__item.is-fullWidth .bx--accordion__content{padding-right:1rem;margin-left:0}\n", ""]);

// exports


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[133,0]]]);
});